// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/user.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/user.proto.
 */
export const file_gitpod_v1_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_gnostic_openapi_v3_annotations, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.GetAuthenticatedUserRequest
 */
export type GetAuthenticatedUserRequest = Message<"gitpod.v1.GetAuthenticatedUserRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetAuthenticatedUserRequest.
 * Use `create(GetAuthenticatedUserRequestSchema)` to create a new message.
 */
export const GetAuthenticatedUserRequestSchema: GenMessage<GetAuthenticatedUserRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 0);

/**
 * @generated from message gitpod.v1.GetAuthenticatedUserResponse
 */
export type GetAuthenticatedUserResponse = Message<"gitpod.v1.GetAuthenticatedUserResponse"> & {
  /**
   * @generated from field: gitpod.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message gitpod.v1.GetAuthenticatedUserResponse.
 * Use `create(GetAuthenticatedUserResponseSchema)` to create a new message.
 */
export const GetAuthenticatedUserResponseSchema: GenMessage<GetAuthenticatedUserResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 1);

/**
 * @generated from message gitpod.v1.GetUserRequest
 */
export type GetUserRequest = Message<"gitpod.v1.GetUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message gitpod.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 2);

/**
 * @generated from message gitpod.v1.GetUserResponse
 */
export type GetUserResponse = Message<"gitpod.v1.GetUserResponse"> & {
  /**
   * @generated from field: gitpod.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message gitpod.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 3);

/**
 * @generated from message gitpod.v1.SetSuspendedRequest
 */
export type SetSuspendedRequest = Message<"gitpod.v1.SetSuspendedRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bool suspended = 2;
   */
  suspended: boolean;
};

/**
 * Describes the message gitpod.v1.SetSuspendedRequest.
 * Use `create(SetSuspendedRequestSchema)` to create a new message.
 */
export const SetSuspendedRequestSchema: GenMessage<SetSuspendedRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 4);

/**
 * @generated from message gitpod.v1.SetSuspendedResponse
 */
export type SetSuspendedResponse = Message<"gitpod.v1.SetSuspendedResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetSuspendedResponse.
 * Use `create(SetSuspendedResponseSchema)` to create a new message.
 */
export const SetSuspendedResponseSchema: GenMessage<SetSuspendedResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 5);

/**
 * @generated from message gitpod.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"gitpod.v1.DeleteUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message gitpod.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 6);

/**
 * @generated from message gitpod.v1.DeleteUserResponse
 */
export type DeleteUserResponse = Message<"gitpod.v1.DeleteUserResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema: GenMessage<DeleteUserResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 7);

/**
 * @generated from message gitpod.v1.User
 */
export type User = Message<"gitpod.v1.User"> & {
  /**
   * id is a UUID of the user
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * organization_id is the id of the organization this account is owned by.
   *
   * +optional if not set, this account is owned by the installation.
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * name is the full name of the user
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * avatar_url is a link to the user avatar
   *
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * created_at is the creation time
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * status is the status the user is in
   *
   * @generated from field: gitpod.v1.UserStatus status = 6;
   */
  status: UserStatus;

  /**
   * email is the user's email address
   *
   * @generated from field: string email = 7;
   */
  email: string;
};

/**
 * Describes the message gitpod.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 8);

/**
 * @generated from message gitpod.v1.CreatePersonalAccessTokenRequest
 */
export type CreatePersonalAccessTokenRequest = Message<"gitpod.v1.CreatePersonalAccessTokenRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Duration valid_for = 3;
   */
  validFor?: Duration;

  /**
   * When true, the token can only be used for read operations.
   * Mutations will be denied at the data layer.
   *
   * @generated from field: bool read_only = 4;
   */
  readOnly: boolean;
};

/**
 * Describes the message gitpod.v1.CreatePersonalAccessTokenRequest.
 * Use `create(CreatePersonalAccessTokenRequestSchema)` to create a new message.
 */
export const CreatePersonalAccessTokenRequestSchema: GenMessage<CreatePersonalAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 9);

/**
 * @generated from message gitpod.v1.CreatePersonalAccessTokenResponse
 */
export type CreatePersonalAccessTokenResponse = Message<"gitpod.v1.CreatePersonalAccessTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.CreatePersonalAccessTokenResponse.
 * Use `create(CreatePersonalAccessTokenResponseSchema)` to create a new message.
 */
export const CreatePersonalAccessTokenResponseSchema: GenMessage<CreatePersonalAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 10);

/**
 * @generated from message gitpod.v1.GetPersonalAccessTokenRequest
 */
export type GetPersonalAccessTokenRequest = Message<"gitpod.v1.GetPersonalAccessTokenRequest"> & {
  /**
   * @generated from field: string personal_access_token_id = 1;
   */
  personalAccessTokenId: string;
};

/**
 * Describes the message gitpod.v1.GetPersonalAccessTokenRequest.
 * Use `create(GetPersonalAccessTokenRequestSchema)` to create a new message.
 */
export const GetPersonalAccessTokenRequestSchema: GenMessage<GetPersonalAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 11);

/**
 * @generated from message gitpod.v1.GetPersonalAccessTokenResponse
 */
export type GetPersonalAccessTokenResponse = Message<"gitpod.v1.GetPersonalAccessTokenResponse"> & {
  /**
   * @generated from field: gitpod.v1.PersonalAccessToken pat = 1;
   */
  pat?: PersonalAccessToken;
};

/**
 * Describes the message gitpod.v1.GetPersonalAccessTokenResponse.
 * Use `create(GetPersonalAccessTokenResponseSchema)` to create a new message.
 */
export const GetPersonalAccessTokenResponseSchema: GenMessage<GetPersonalAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 12);

/**
 * @generated from message gitpod.v1.ListPersonalAccessTokensRequest
 */
export type ListPersonalAccessTokensRequest = Message<"gitpod.v1.ListPersonalAccessTokensRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListPersonalAccessTokensRequest.Filter filter = 2;
   */
  filter?: ListPersonalAccessTokensRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListPersonalAccessTokensRequest.
 * Use `create(ListPersonalAccessTokensRequestSchema)` to create a new message.
 */
export const ListPersonalAccessTokensRequestSchema: GenMessage<ListPersonalAccessTokensRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 13);

/**
 * @generated from message gitpod.v1.ListPersonalAccessTokensRequest.Filter
 */
export type ListPersonalAccessTokensRequest_Filter = Message<"gitpod.v1.ListPersonalAccessTokensRequest.Filter"> & {
  /**
   * creator_ids filters the response to only Environments created by specified members
   *
   * @generated from field: repeated string user_ids = 3;
   */
  userIds: string[];
};

/**
 * Describes the message gitpod.v1.ListPersonalAccessTokensRequest.Filter.
 * Use `create(ListPersonalAccessTokensRequest_FilterSchema)` to create a new message.
 */
export const ListPersonalAccessTokensRequest_FilterSchema: GenMessage<ListPersonalAccessTokensRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 13, 0);

/**
 * @generated from message gitpod.v1.ListPersonalAccessTokensResponse
 */
export type ListPersonalAccessTokensResponse = Message<"gitpod.v1.ListPersonalAccessTokensResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.PersonalAccessToken personal_access_tokens = 2;
   */
  personalAccessTokens: PersonalAccessToken[];
};

/**
 * Describes the message gitpod.v1.ListPersonalAccessTokensResponse.
 * Use `create(ListPersonalAccessTokensResponseSchema)` to create a new message.
 */
export const ListPersonalAccessTokensResponseSchema: GenMessage<ListPersonalAccessTokensResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 14);

/**
 * @generated from message gitpod.v1.DeletePersonalAccessTokenRequest
 */
export type DeletePersonalAccessTokenRequest = Message<"gitpod.v1.DeletePersonalAccessTokenRequest"> & {
  /**
   * @generated from field: string personal_access_token_id = 1;
   */
  personalAccessTokenId: string;
};

/**
 * Describes the message gitpod.v1.DeletePersonalAccessTokenRequest.
 * Use `create(DeletePersonalAccessTokenRequestSchema)` to create a new message.
 */
export const DeletePersonalAccessTokenRequestSchema: GenMessage<DeletePersonalAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 15);

/**
 * @generated from message gitpod.v1.DeletePersonalAccessTokenResponse
 */
export type DeletePersonalAccessTokenResponse = Message<"gitpod.v1.DeletePersonalAccessTokenResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeletePersonalAccessTokenResponse.
 * Use `create(DeletePersonalAccessTokenResponseSchema)` to create a new message.
 */
export const DeletePersonalAccessTokenResponseSchema: GenMessage<DeletePersonalAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 16);

/**
 * @generated from message gitpod.v1.PersonalAccessToken
 */
export type PersonalAccessToken = Message<"gitpod.v1.PersonalAccessToken"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_used = 7;
   */
  lastUsed?: Timestamp;

  /**
   * When true, the token can only be used for read operations.
   * Mutations will be denied at the data layer.
   *
   * @generated from field: bool read_only = 8;
   */
  readOnly: boolean;
};

/**
 * Describes the message gitpod.v1.PersonalAccessToken.
 * Use `create(PersonalAccessTokenSchema)` to create a new message.
 */
export const PersonalAccessTokenSchema: GenMessage<PersonalAccessToken> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 17);

/**
 * @generated from message gitpod.v1.SetPreferenceRequest
 */
export type SetPreferenceRequest = Message<"gitpod.v1.SetPreferenceRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * omitting value field will cause an error due to min_len validation,
   * to unset a preference use DeletePreference instead
   *
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message gitpod.v1.SetPreferenceRequest.
 * Use `create(SetPreferenceRequestSchema)` to create a new message.
 */
export const SetPreferenceRequestSchema: GenMessage<SetPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 18);

/**
 * @generated from message gitpod.v1.SetPreferenceResponse
 */
export type SetPreferenceResponse = Message<"gitpod.v1.SetPreferenceResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetPreferenceResponse.
 * Use `create(SetPreferenceResponseSchema)` to create a new message.
 */
export const SetPreferenceResponseSchema: GenMessage<SetPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 19);

/**
 * @generated from message gitpod.v1.GetPreferenceRequest
 */
export type GetPreferenceRequest = Message<"gitpod.v1.GetPreferenceRequest"> & {
  /**
   * @generated from field: string user_preference_id = 1 [deprecated = true];
   * @deprecated
   */
  userPreferenceId: string;

  /**
   * an identifier for the preference to get
   *
   * @generated from oneof gitpod.v1.GetPreferenceRequest.preference
   */
  preference: {
    /**
     * @generated from field: string preference_id = 2;
     */
    value: string;
    case: "preferenceId";
  } | {
    /**
     * @generated from field: string preference_key = 3;
     */
    value: string;
    case: "preferenceKey";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.GetPreferenceRequest.
 * Use `create(GetPreferenceRequestSchema)` to create a new message.
 */
export const GetPreferenceRequestSchema: GenMessage<GetPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 20);

/**
 * @generated from message gitpod.v1.GetPreferenceResponse
 */
export type GetPreferenceResponse = Message<"gitpod.v1.GetPreferenceResponse"> & {
  /**
   * @generated from field: gitpod.v1.UserPreference preference = 1;
   */
  preference?: UserPreference;
};

/**
 * Describes the message gitpod.v1.GetPreferenceResponse.
 * Use `create(GetPreferenceResponseSchema)` to create a new message.
 */
export const GetPreferenceResponseSchema: GenMessage<GetPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 21);

/**
 * @generated from message gitpod.v1.ListPreferencesRequest
 */
export type ListPreferencesRequest = Message<"gitpod.v1.ListPreferencesRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListPreferencesRequest.
 * Use `create(ListPreferencesRequestSchema)` to create a new message.
 */
export const ListPreferencesRequestSchema: GenMessage<ListPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 22);

/**
 * @generated from message gitpod.v1.ListPreferencesResponse
 */
export type ListPreferencesResponse = Message<"gitpod.v1.ListPreferencesResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.UserPreference preferences = 2;
   */
  preferences: UserPreference[];
};

/**
 * Describes the message gitpod.v1.ListPreferencesResponse.
 * Use `create(ListPreferencesResponseSchema)` to create a new message.
 */
export const ListPreferencesResponseSchema: GenMessage<ListPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 23);

/**
 * @generated from message gitpod.v1.DeletePreferenceRequest
 */
export type DeletePreferenceRequest = Message<"gitpod.v1.DeletePreferenceRequest"> & {
  /**
   * @generated from field: string user_preference_id = 1;
   */
  userPreferenceId: string;
};

/**
 * Describes the message gitpod.v1.DeletePreferenceRequest.
 * Use `create(DeletePreferenceRequestSchema)` to create a new message.
 */
export const DeletePreferenceRequestSchema: GenMessage<DeletePreferenceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 24);

/**
 * @generated from message gitpod.v1.DeletePreferenceResponse
 */
export type DeletePreferenceResponse = Message<"gitpod.v1.DeletePreferenceResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeletePreferenceResponse.
 * Use `create(DeletePreferenceResponseSchema)` to create a new message.
 */
export const DeletePreferenceResponseSchema: GenMessage<DeletePreferenceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 25);

/**
 * @generated from message gitpod.v1.UserPreference
 */
export type UserPreference = Message<"gitpod.v1.UserPreference"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * omitting value field will cause an error due to min_len validation,
   * to unset a preference use DeletePreference instead
   *
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.UserPreference.
 * Use `create(UserPreferenceSchema)` to create a new message.
 */
export const UserPreferenceSchema: GenMessage<UserPreference> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 26);

/**
 * @generated from message gitpod.v1.GetDotfilesConfigurationRequest
 */
export type GetDotfilesConfigurationRequest = Message<"gitpod.v1.GetDotfilesConfigurationRequest"> & {
};

/**
 * Describes the message gitpod.v1.GetDotfilesConfigurationRequest.
 * Use `create(GetDotfilesConfigurationRequestSchema)` to create a new message.
 */
export const GetDotfilesConfigurationRequestSchema: GenMessage<GetDotfilesConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 27);

/**
 * @generated from message gitpod.v1.GetDotfilesConfigurationResponse
 */
export type GetDotfilesConfigurationResponse = Message<"gitpod.v1.GetDotfilesConfigurationResponse"> & {
  /**
   * @generated from field: gitpod.v1.DotfilesConfiguration dotfiles_configuration = 1;
   */
  dotfilesConfiguration?: DotfilesConfiguration;
};

/**
 * Describes the message gitpod.v1.GetDotfilesConfigurationResponse.
 * Use `create(GetDotfilesConfigurationResponseSchema)` to create a new message.
 */
export const GetDotfilesConfigurationResponseSchema: GenMessage<GetDotfilesConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 28);

/**
 * @generated from message gitpod.v1.SetDotfilesConfigurationRequest
 */
export type SetDotfilesConfigurationRequest = Message<"gitpod.v1.SetDotfilesConfigurationRequest"> & {
  /**
   * @generated from field: string repository = 1;
   */
  repository: string;
};

/**
 * Describes the message gitpod.v1.SetDotfilesConfigurationRequest.
 * Use `create(SetDotfilesConfigurationRequestSchema)` to create a new message.
 */
export const SetDotfilesConfigurationRequestSchema: GenMessage<SetDotfilesConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 29);

/**
 * @generated from message gitpod.v1.SetDotfilesConfigurationResponse
 */
export type SetDotfilesConfigurationResponse = Message<"gitpod.v1.SetDotfilesConfigurationResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetDotfilesConfigurationResponse.
 * Use `create(SetDotfilesConfigurationResponseSchema)` to create a new message.
 */
export const SetDotfilesConfigurationResponseSchema: GenMessage<SetDotfilesConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 30);

/**
 * @generated from message gitpod.v1.DotfilesConfiguration
 */
export type DotfilesConfiguration = Message<"gitpod.v1.DotfilesConfiguration"> & {
  /**
   * The URL of a dotfiles repository.
   *
   * @generated from field: string repository = 1;
   */
  repository: string;
};

/**
 * Describes the message gitpod.v1.DotfilesConfiguration.
 * Use `create(DotfilesConfigurationSchema)` to create a new message.
 */
export const DotfilesConfigurationSchema: GenMessage<DotfilesConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_user, 31);

/**
 * @generated from enum gitpod.v1.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: USER_STATUS_SUSPENDED = 2;
   */
  SUSPENDED = 2,

  /**
   * @generated from enum value: USER_STATUS_LEFT = 3;
   */
  LEFT = 3,
}

/**
 * Describes the enum gitpod.v1.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_user, 0);

/**
 * @generated from service gitpod.v1.UserService
 */
export const UserService: GenService<{
  /**
   * Gets information about the currently authenticated user.
   *
   * Use this method to:
   * - Get user profile information
   * - Check authentication status
   * - Retrieve user settings
   * - Verify account details
   *
   * ### Examples
   *
   * - Get current user:
   *
   *   Retrieves details about the authenticated user.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.GetAuthenticatedUser
   */
  getAuthenticatedUser: {
    methodKind: "unary";
    input: typeof GetAuthenticatedUserRequestSchema;
    output: typeof GetAuthenticatedUserResponseSchema;
  },
  /**
   * Gets basic information about a specific user by their ID.
   *
   * Use this method to:
   * - Retrieve user profile information
   * - Get user details for display purposes
   * - Fetch user metadata for administrative tasks
   *
   * ### Examples
   *
   * - Get user by ID:
   *
   *   Retrieves basic user information by user ID.
   *
   *   ```yaml
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * Sets whether a user account is suspended.
   *
   * Use this method to:
   * - Suspend problematic users
   * - Reactivate suspended accounts
   * - Manage user access
   *
   * ### Examples
   *
   * - Suspend user:
   *
   *   Suspends a user account.
   *
   *   ```yaml
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   suspended: true
   *   ```
   *
   * - Reactivate user:
   *
   *   Removes suspension from a user account.
   *
   *   ```yaml
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   suspended: false
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.SetSuspended
   */
  setSuspended: {
    methodKind: "unary";
    input: typeof SetSuspendedRequestSchema;
    output: typeof SetSuspendedResponseSchema;
  },
  /**
   * Deletes a user. If the User comes from an organization's SSO provider, the Account will also be deleted.
   *
   * @generated from rpc gitpod.v1.UserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof DeleteUserResponseSchema;
  },
  /**
   * Creates a new personal access token for API authentication.
   *
   * Use this method to:
   * - Generate API access tokens
   * - Create service account credentials
   * - Set up automated access
   *
   * ### Examples
   *
   * - Create token:
   *
   *   Creates a new access token valid for 30 days.
   *
   *   ```yaml
   *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
   *   description: "CI/CD Pipeline Token"
   *   validFor: "2592000s"  # 30 days
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.CreatePersonalAccessToken
   */
  createPersonalAccessToken: {
    methodKind: "unary";
    input: typeof CreatePersonalAccessTokenRequestSchema;
    output: typeof CreatePersonalAccessTokenResponseSchema;
  },
  /**
   * Gets details about a specific personal access token.
   *
   * Use this method to:
   * - View token metadata
   * - Check token expiration
   * - Monitor token usage
   *
   * ### Examples
   *
   * - Get token details:
   *
   *   Retrieves information about a specific token.
   *
   *   ```yaml
   *   personalAccessTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.GetPersonalAccessToken
   */
  getPersonalAccessToken: {
    methodKind: "unary";
    input: typeof GetPersonalAccessTokenRequestSchema;
    output: typeof GetPersonalAccessTokenResponseSchema;
  },
  /**
   * Lists personal access tokens with optional filtering.
   *
   * Use this method to:
   * - View all active tokens
   * - Audit token usage
   * - Manage token lifecycle
   *
   * ### Examples
   *
   * - List user tokens:
   *
   *   Shows all tokens for specific users.
   *
   *   ```yaml
   *   filter:
   *     userIds: ["f53d2330-3795-4c5d-a1f3-453121af9c60"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.ListPersonalAccessTokens
   */
  listPersonalAccessTokens: {
    methodKind: "unary";
    input: typeof ListPersonalAccessTokensRequestSchema;
    output: typeof ListPersonalAccessTokensResponseSchema;
  },
  /**
   * Deletes a personal access token.
   *
   * Use this method to:
   * - Revoke token access
   * - Remove unused tokens
   * - Rotate credentials
   *
   * ### Examples
   *
   * - Delete token:
   *
   *   Permanently revokes a token.
   *
   *   ```yaml
   *   personalAccessTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.DeletePersonalAccessToken
   */
  deletePersonalAccessToken: {
    methodKind: "unary";
    input: typeof DeletePersonalAccessTokenRequestSchema;
    output: typeof DeletePersonalAccessTokenResponseSchema;
  },
  /**
   * Sets a user preference value.
   *
   * Use this method to:
   * - Store user settings
   * - Update preferences
   * - Configure user experience
   *
   * ### Examples
   *
   * - Set preference:
   *
   *   Updates a user preference setting.
   *
   *   ```yaml
   *   key: "theme"
   *   value: "dark"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.SetPreference
   */
  setPreference: {
    methodKind: "unary";
    input: typeof SetPreferenceRequestSchema;
    output: typeof SetPreferenceResponseSchema;
  },
  /**
   * Gets a specific user preference value.
   *
   * Use this method to:
   * - Retrieve user settings
   * - Read preference values
   * - Check configurations
   *
   * ### Examples
   *
   * - Get preference:
   *
   *   Retrieves a specific preference value.
   *
   *   ```yaml
   *   preferenceId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.GetPreference
   */
  getPreference: {
    methodKind: "unary";
    input: typeof GetPreferenceRequestSchema;
    output: typeof GetPreferenceResponseSchema;
  },
  /**
   * Lists all user preferences.
   *
   * Use this method to:
   * - View all user settings
   * - Export preferences
   * - Audit configurations
   *
   * ### Examples
   *
   * - List preferences:
   *
   *   Shows all preferences with pagination.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.ListPreferences
   */
  listPreferences: {
    methodKind: "unary";
    input: typeof ListPreferencesRequestSchema;
    output: typeof ListPreferencesResponseSchema;
  },
  /**
   * Deletes a user preference.
   *
   * Use this method to:
   * - Remove settings
   * - Reset preferences
   * - Clean up configurations
   *
   * ### Examples
   *
   * - Delete preference:
   *
   *   Removes a specific preference.
   *
   *   ```yaml
   *   userPreferenceId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.DeletePreference
   */
  deletePreference: {
    methodKind: "unary";
    input: typeof DeletePreferenceRequestSchema;
    output: typeof DeletePreferenceResponseSchema;
  },
  /**
   * Gets the dotfiles for a user.
   *
   * Use this method to:
   * - Retrieve user dotfiles
   *
   * ### Examples
   *
   * - Get dotfiles:
   *
   *   Retrieves the dotfiles for the current user.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.GetDotfilesConfiguration
   */
  getDotfilesConfiguration: {
    methodKind: "unary";
    input: typeof GetDotfilesConfigurationRequestSchema;
    output: typeof GetDotfilesConfigurationResponseSchema;
  },
  /**
   * Sets the dotfiles configuration for a user.
   *
   * Use this method to:
   * - Configure user dotfiles
   * - Update dotfiles settings
   *
   * ### Examples
   *
   * - Set dotfiles configuration:
   *
   *   Sets the dotfiles configuration for the current user.
   *
   *   ```yaml
   *   {
   *     "repository": "https://github.com/gitpod-io/dotfiles",
   *   }
   *   ```
   *
   * - Remove dotfiles:
   *
   *   Removes the dotfiles for the current user.
   *
   *   ```yaml
   *   {}
   *   ```
   *
   * @generated from rpc gitpod.v1.UserService.SetDotfilesConfiguration
   */
  setDotfilesConfiguration: {
    methodKind: "unary";
    input: typeof SetDotfilesConfigurationRequestSchema;
    output: typeof SetDotfilesConfigurationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_user, 0);

